import * as React from 'react';
import lineClamp from 'line-clamp';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const LineClampCont = styled.div`
    line-height: 20px;
`;

export const LineClamp = ({ content, clampAt = 3 }) => {
    const ref = React.useRef(null);

    React.useEffect(() => {
        if (ref?.current) {
            lineClamp(ref?.current, clampAt);
        }
    }, []);

    return <LineClampCont ref={ref}>{content}</LineClampCont>;
};

LineClamp.propTypes = {
    content: PropTypes.string,
    clampAt: PropTypes.number
};
